webpackJsonp([142629428675168],{

/***/ 315:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Gatsby Typescript Starter"}}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---index-f76831fd5dd1e08e3ff8.js